import React from 'react';
import { useTranslations } from 'next-intl';

import { calculateDiscount } from 'modules/global';

import { Visible } from 'components';

interface IProps {
  price?: number;
  discount?: number;
  isFree?: boolean;
}

const Price: React.FC<IProps> = ({ discount, isFree, price }) => {
  const t = useTranslations();

  return (
    <div className="flex flex-col">
      <Visible if={!isFree && !discount && !!price}>
        <span className="text-lg font-medium">
          {price?.toLocaleString('ru')} {t('sum')}
        </span>
      </Visible>
      <Visible if={!isFree && !!discount}>
        <div className="flex flex-col">
          <div className="w-max max-w-full rounded-md bg-purple-200 px-2 py-0.5 text-[0.625rem] font-medium text-purple-600 sm:bg-green-50 sm:text-green-500">
            {t('akam_pro_bilan')} -{discount}%
          </div>
          <span className="text-lg font-medium text-purple-600 sm:text-green-500">
            {calculateDiscount(price, discount)?.toLocaleString('ru')}
          </span>
          <span className="text-xs font-medium">
            {t('akam_pro_siz')} {price?.toLocaleString('ru')}
          </span>
        </div>
      </Visible>
      <Visible if={isFree}>
        <div className="mt-2 w-max rounded-full bg-purple-600 px-1.5 py-0.5 text-xs font-medium text-white sm:bg-green-600">
          {t('bepul')}
        </div>
      </Visible>
    </div>
  );
};

export default Price;
